import { Component, EventEmitter, Input, OnChanges, OnInit, Output } from '@angular/core';
import { WSImport } from '../import.models';
import { DataService, DataFilter } from '../../services/data.service';
import { LocalizationService } from '../../services/localization.service';
import { EnvironmentService, RealmData } from '../../services/environment.service';
import { HttpClient } from '@angular/common/http';
import { PersistenceService } from '../../services/persistence.service';
import { PGUtilities } from '../../utilities/pg-utilities';
import { PgImportPreviewModalComponent } from '../pg-import-preview-modal/pg-import-preview-modal.component';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Observable, Subscription } from 'rxjs';

class PGImportResourceTable {
    columns:Array<{ 
        id: string, 
        label: string,
        width?:string
    }> = []
    rows:Array<any> = []
}

@Component({
    selector: 'app-pg-import-resource',
    templateUrl: './pg-import-resource.component.html',
    styleUrls: ['./pg-import-resource.component.scss'],
    standalone: false
})
export class PgImportResourceComponent implements OnInit, OnChanges {

    constructor(private http:HttpClient, private persistenceService:PersistenceService, private localizationService:LocalizationService, private modalService:NgbModal) { }

    @Input() importType:WSImport.JobType
    @Input() APIUrl:string
    @Input() allowedRealms:Array<string|number> = null
    @Input() resourceId:string

    @Input() selection:Array<string>
    @Output() selectionChange = new EventEmitter<Array<string>>()

    dataService:DataService;

    realmData:Array<RealmData> = null;
    realmsOptions:Array<{ value: string, text: string }> = null;
    realmSelection:string = null;

    ngOnInit(): void {
    }

    isLoading = false;

    private _loadingSubscription:Subscription = null;

    ngOnChanges(simpleChanges) {
        if(simpleChanges.importType || simpleChanges.APIUrl) {
            this.dataService = null;

            this.realmData = null;
            this.realmsOptions = null;
            this.realmSelection = null;
            
            this.tableData = null;
            
            this.currentPage = -1;
            this.isAtEnd = false;

            if(this._loadingSubscription != null) this._loadingSubscription.unsubscribe();
    
            if(this.importType == 'entourance') {
                this.isLoading = true;
    
                this._loadingSubscription = this._getDataService(this.APIUrl).subscribe((data) => {
                    this.dataService = data;

                    this.isLoading = false;

                    this._loadingSubscription = this.dataService.getRealms().subscribe((data) => {
                        this.realmData = data;    
                        this._buildRealmsOptions();
                    })

                    this.loadResource()
                })
            }
            else if(this.importType == 'wordpress') {
                this.loadResource()
            }
        }
        else if(simpleChanges.allowedRealms) {
            this._buildRealmsOptions();
            if(this.realmSelection != null && this.allowedRealms?.length) {
                let _allowed = this.allowedRealms.map((_id) => String(_id));
                if(!_allowed.includes(String(this.realmSelection))) {
                    this.realmSelection = null;
                    this.onSearchChange();
                }
            }
        }
        else if(simpleChanges.resourceId) {
            this.loadResource()
        }
    }

    private _buildRealmsOptions() {
        if(this.realmData == null) {
            this.realmsOptions = null;
            return;
        }

        this.realmsOptions = [];

        let _allowed = this.allowedRealms?.length
            ? this.allowedRealms.map((_id) => String(_id))
            : null;

        for(let _realm of this.realmData) {
            if(_realm.name != 'null') {
                if(_allowed != null && !_allowed.includes(String(_realm.id))) {
                    continue;
                }

                this.realmsOptions.push({
                    value: _realm.id,
                    text: _realm.name,
                })
            }
        }

        this.realmsOptions.sort((a, b) => {
            let _aText = a.text.toLowerCase();
            let _bText = b.text.toLowerCase();

            if(_aText < _bText) return -1;
            else if(_aText > _bText) return 1;
            else return 0;
        })
    }

    private _getDataService(APIUrl:string) {
        return new Observable<DataService>((observer) => {
            let _environmentService = new EnvironmentService(this.http)

            _environmentService.init({
                APIUrl: APIUrl
            }, 'importer', null, true).then(() => {
                let _dataService = new DataService(this.http, this.persistenceService)
                _dataService.init(_environmentService, null)

                observer.next(_dataService)
                observer.unsubscribe()
            })
        })
    }

    getSelectedRealmData() {
        for(let _item of this.realmData) {
            if(_item.id == this.realmSelection) {
                return _item;
            }
        }
    }
    
    loadResource() {
        if(this.resourceId) {
            this.tableData = new PGImportResourceTable()

            this.currentPage = -1;
            this.isAtEnd = false;

            if(this.importType == 'entourance') {
                let _fields:Array<string> = []

                if(this.resourceId == 'Experience' || /^Experience~/.test(this.resourceId)) {
                    _fields = ['id','title','city','availability']
                }
                else if(this.resourceId == 'Article') {
                    _fields = ['id','title','city']
                }
                else {
                    _fields = ['id','name','city']
                }

                for(let _item of _fields) {
                    this.tableData.columns.push({ 
                        id: _item, 
                        label: this.localizationService.translateResourceField(this.resourceId.replace(/~.*$/, ''), _item),
                        width: _item == 'id' ? '5em' : null
                    })
                }

                this.loadData();
            }
            else if(this.importType == 'wordpress') {
                let _fields = ['id','title','city']
    
                for(let _item of _fields) {
                    this.tableData.columns.push({ 
                        id: _item, 
                        label: this.localizationService.translateResourceField(this.resourceId.replace(/~.*$/, ''), _item),
                        width: _item == 'id' ? '5em' : null
                    })
                }
    
                this.loadData();
            }
        }
    }

    searchValue:string = null;
    appliedSearchValue:string = null;

    onSearchChange() {
        this.tableData.rows = [];
        
        this.currentPage = -1;
        this.isAtEnd = false;

        this.appliedSearchValue = this.searchValue

        this.loadData();
    }

    isLoadingData = false;
    isAtEnd = false;

    currentPage = -1;
    pageSize = 10;

    tableData:PGImportResourceTable = null;

    loadData(andSelect?:boolean) {
        this.currentPage++;
        this.isLoadingData = true;

        if(this.importType == 'entourance') {
            if(andSelect) this.isSelectingData = true;

            let _filter:Array<DataFilter> = null;
            if(this.realmSelection) {
                _filter = [{
                    field: 'realm_id',
                    operator: '==',
                    value: [this.realmSelection]
                }]
            }
            else if(this.allowedRealms?.length) {
                _filter = [{
                    field: 'realm_id',
                    operator: 'in',
                    value: this.allowedRealms.map((_id) => String(_id))
                }]
            }

            this._loadingSubscription = this.dataService.getResourceData(this.resourceId, { 
                offset: this.currentPage * this.pageSize, 
                limit: this.pageSize + 1,
                filter: _filter,
                search: this.appliedSearchValue
            }, null, null, 'public').subscribe((data) => {
                this.isLoadingData = false;
                if(andSelect) this.isSelectingData = false;

                if(data == null) this.isAtEnd = true;
                else {
                    if(data.length < this.pageSize + 1) this.isAtEnd = true;

                    for(let i = 0; i < this.pageSize; i++) {
                        let _row = data[i];

                        if(_row != null) {
                            this.tableData.rows.push(_row)
    
                            if(andSelect) {
                                this.selection.push(_row.id)
                            }
                        }
                    }

                    if(andSelect) {
                        if(!this.isAtEnd) this.loadData(andSelect)
                        else this.selectionChange.emit(this.selection)
                    }
                }
            })
        }
        else if(this.importType == 'wordpress') {
            let _1BasedCurrentPage = this.currentPage + 1;

            this._loadingSubscription = this.http.get(this.APIUrl + '?per_page=' + this.pageSize + '&page=' + _1BasedCurrentPage).subscribe((data:any) => {
                this.isLoadingData = false;

                if(_1BasedCurrentPage >= data.total_pages) this.isAtEnd = true;

                for(let _item of data.events) {
                    this.tableData.rows.push({
                        id: _item.id,
                        title: _item.title,
                        cover: _item.image?.url,
                        description: _item.description,
                        city: _item.venue?.city
                    })
                }
            })
        }
        else {
            this.isLoadingData = false;
            this.isAtEnd = true
        }
    }
    

    getRowFieldOrTranslation(row:any, field:string) {
        if(this.importType == 'entourance') {
            if(row.translations) {
                for(let _item of row.translations) {
                    if(_item.language == this.localizationService.currentLanguage) {
                        let _cleanTranslation = PGUtilities.cleanTranslation(_item.translations)
            
                        if(_cleanTranslation[field]) return _cleanTranslation[field]
                        break; 
                    }
                }
            }

            if(field == 'availability') {
                return this.localizationService.format.timetable('dates', row[field])
            }
            else {
                return this.localizationService.translateOptionMapValue(this.resourceId.replace(/~.*$/, ''), field, row[field])
            }
        }
        else {
            return PGUtilities.resolveObjectPath(row, field)
        }
    } 

    isSelected(id:string) {
        return this.selection && this.selection.indexOf(id) != -1
    }

    setSelected(id:string, val:boolean) {
        if(this.selection) {
            if(val) {
                if(!this.isSelected(id)) {
                    this.selection.push(id)
                    this.selectionChange.emit(this.selection)
                }
            }
            else {
                if(this.isSelected(id)) {
                    let _index = this.selection.indexOf(id)
                    this.selection.splice(_index, 1)
                    this.selectionChange.emit(this.selection)
                }
            }
        }
    }

    isSelectingData = false;

    canSelectAll() { 
        return !this.isLoading && !this.isLoadingData && !this.isSelectingData && this.tableData && this.tableData.rows.length > this.selection.length
    }

    selectAll() {
        if(this.canSelectAll()) {
            this.selection.splice(0)
    
            for(let _item of this.tableData.rows) {
                this.selection.push(_item.id)
            }

            if(!this.isAtEnd) this.loadData(true)
            else this.selectionChange.emit(this.selection)
        }
    }

    openPreview(id:string) {
        let _modalRef = this.modalService.open(PgImportPreviewModalComponent, { size: 'xl' })
        let _componentInstance = _modalRef.componentInstance as PgImportPreviewModalComponent;

        _componentInstance.importType = this.importType;
        _componentInstance.APIUrl = this.APIUrl;
        _componentInstance.resourceName = this.resourceId;
        _componentInstance.elementId = id;

        _componentInstance.ngOnInit()
    }
}
